<div style="padding: 20px" class="buyer_container">
  <h4 style=" margin-top: 0">Buyer choice</h4>
  <form [formGroup]="buyerChoiceForm">
    <mat-radio-group formControlName="colorScheme" style="margin-bottom: 20px">
      <h4
        [ngStyle]="{color: submitted && f.isLocalDownsize.errors ? '#f44336' : '#DEDEDE', fontFamily: 'Poppins Regular', marginTop: '20px', marginBottom: '10px', fontSize: '14px'}">
        What color scheme does the buyer need?</h4>
      <mat-radio-button [value]=1 style="margin-right: 40px">
        Light
      </mat-radio-button>
      <mat-radio-button [value]=0>
        Dark
      </mat-radio-button>
    </mat-radio-group>
    <mat-radio-group formControlName="mobileBenchOption" style="margin-bottom: 20px">
      <h4
        [ngStyle]="{color: submitted && f.isLocalDownsize.errors ? '#f44336' : '#DEDEDE', fontFamily: 'Poppins Regular', marginTop: '20px', marginBottom: '10px', fontSize: '14px'}">
        Does the buyer need mobile bench?</h4>
      <mat-radio-button [value]=1 style="margin-right: 40px">
        Yes
      </mat-radio-button>
      <mat-radio-button [value]=0>
        No
      </mat-radio-button>
    </mat-radio-group>
    <mat-radio-group formControlName="dishAccessory" style="margin-bottom: 20px">
      <h4
        [ngStyle]="{color: submitted && f.isLocalDownsize.errors ? '#f44336' : '#DEDEDE', fontFamily: 'Poppins Regular', marginTop: '20px', marginBottom: '10px', fontSize: '14px'}">
        Which does the buyer need, dish washer or dish drawer?</h4>
      <mat-radio-button [value]=1 style="margin-right: 40px">
        Dish washer
      </mat-radio-button>
      <mat-radio-button [value]=0>
        Dish drawer
      </mat-radio-button>
    </mat-radio-group>
    <div>
      <button mat-button (click)="submit()"
        style="margin-top: 40px; background: #161616; color: #dedede;border: 1px solid #dedede; ">Submit</button>
    </div>
  </form>
</div>